const initialState = {
  players: {},
  events: {},
  news: {},
  instructions: {},
  members: {},
  activeEvents: [],
};

function statisticsReducer(state = initialState, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    default:
      return newState;
  }
}

export default statisticsReducer;
